export class Row {
  [key: string]: string;
}

export class List {
  constructor(public header: HeaderList[], public list: Data) {}
}

export class HeaderList {
  constructor(
    public name: string,
    public field: string,
    public padding?: string,
    public textAlign?: string
  ) {}
}

export type Data = any[];
